import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    RadioGroupDynamicStyleConstantType,
    RadioGroupDynamicStyleType
} from "./type";
import fieldGroupStylesheet, {
    useStyles as useFieldGroupStyles
} from "../field/components/group/stylesheet";
import type {
    Mutable
} from "../../types";

const stylesheet = StyleSheet.create({
    container: {
        ...fieldGroupStylesheet.container
    },
    horizontalContainer: {
        flexDirection: "row",
        flexWrap: "wrap"
    }
});

export const useStyles = ({
    isOptionList,
    orientation,
    spaces
}: RadioGroupDynamicStyleConstantType): RadioGroupDynamicStyleType => {
    const {
        container: fieldGroupContainer
    } = useFieldGroupStyles({
        isOptionList,
        spaces
    });

    const container = {
        ...fieldGroupContainer
    } as Mutable<ViewStyle>;

    if(orientation === "horizontal") {
        Object.assign(container, stylesheet.horizontalContainer, {
            rowGap: fieldGroupContainer.gap,
            columnGap: spaces.spacingLg
        });

        delete container.gap;
    }

    return {
        container
    };
};
export default stylesheet;
